// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"d9376b93","222":"07b5cefd","302":"407be0fa","369":"c6dd32fc","389":"327f6b84","920":"4556a703"}[chunkId] + ".chunk.js";
};